import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { HttpClient } from '@angular/common/http';

import { Salarie } from './../../../core/models/salarie';
import { Observable, map } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SalarieService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* create salarie */
  createsalarie(body: any): Observable<ApiResponse<Salarie>> {
    return this._http.post<ApiResponse<Salarie>>(
      this._base + '/api/ConsultantClientFinal/associateSalarieToClientFinal',
      body
    );
  }

  /* get list salarie */

  getListsalarie(data: {
    clientFinal_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;

    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/ConsultantClientFinal/getSalariesByClientFinal?clientFinal_id=${data.clientFinal_id}&per_page=${data.per_page}&page=${data.page}${sort}`
    );
  }

  getskillssalarie(idcandidat: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        `${this._base}/api/Skill/getSkillsByCandidate/${idcandidat}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  /*update salarie  */
  updatesalarier(updatedsalarieData: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/ConsultantClientFinal/updateSalary`,
      updatedsalarieData
    );
  }

  /*update salarie  */
  updatesalarie(
    salarieId: number,
    updatedsalarieData: any
  ): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/JobRequest/update/${salarieId}`,
      updatedsalarieData
    );
  }
  ///////////////////////////////////////////////////////////////////////////////////////////

  // delete salarie
  deletesalarie(salarieId: any): Observable<any> {
    return this._http.delete(
      `${this._base}/api/JobRequest/delete/${salarieId}`
    );
  }

  downloadFile(url: string) {
    return this._http.get(url, { responseType: 'blob' });
  }
  downloadPDF(url: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' };
    return this._http
      .get<Blob>(url, options)
      .pipe(map((res: any) => new Blob([res], { type: 'application/pdf' })));
  }

  getSkills(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/SubCategory/getListSubCateg`
    );
  }
  getSkillsJobs() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/SubCategory/getListSubCateg`
    );
  }

  getsalariebyemail(email: any, client_id: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/ConsultantClientFinal/getSalarieByMail?email=${email}&client_id=${client_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  /*get salarie  by id */
  getsalarieById(
    clientFinal_id: number,
    candidate_id: number
  ): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base +
          `/api/ConsultantClientFinal/getSalarieByIdWithDetails?clientFinal_id=${clientFinal_id}&candidate_id=${candidate_id}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  // search salarie//////
  searchsalarie(data: any): Observable<ApiResponse<any>> {
    let tabs = this.findDoubleQuotes(data.search);
    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    console.log(
      'data of searchCandidat',
      'count = ' + tabs.length,
      data.search
    );

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/ConsultantClientFinal/searchSalariesForClientFinal`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }

  /*add Bulk Candidates*/
  addBulkCandidates(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/ConsultantClientFinal/addBulkSalary`,
      data
    );
  }
  /*get bulk candidate */
  getbulkCandidate(data: any) {
    return this._http.get(
      this._base + `/api/ConsultantClientFinal/exportSalary/${data}`,
      {
        responseType: 'arraybuffer',
      }
    );
  }
  getHeaderElementssalariecf(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`
    );
  }
  changeDelectedElementHeadesalariecf(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }
  downloadcsvfileAddBulksalarie() {
    const url = `${this._base}/api/ConsultantClientFinal/uploadEmptyFileAddBulkSalary`;
    console.log('url', url);
    return this._http.get(url, {
      responseType: 'blob', // Changer 'arraybuffer' en 'blob'
      // observe: 'response', // Permet d'obtenir la réponse complète incluant les en-têtes
    });
  }
}
